import { Button } from "@/components/ui/button"
import { useNapForm } from "../NapFormContext"
import { LookupItem } from "@/types/activity"
import { Star } from "lucide-react"

interface RestfulnessStepProps {
  restfulnessRatings: LookupItem[]
  childName?: string
  onNext: () => void
  onPrev?: () => void
}

export function RestfulnessStep({ restfulnessRatings, childName, onNext, onPrev }: RestfulnessStepProps) {
  // Access form through context
  const form = useNapForm();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-center">
        How was {childName || 'your baby\'s'} nap?
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
        {restfulnessRatings.map((rating) => (
          <Button
            key={rating.id}
            type="button"
            variant={form.watch("restfulness_id") === rating.id ? "default" : "outline"}
            className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
            onClick={() => {
              form.setValue("restfulness_id", rating.id)
              form.clearErrors("restfulness_id")
              onNext()
            }}
          >
            <Star className="mr-2 h-4 w-4 shrink-0" />
            <span className="text-sm line-clamp-2">{rating.name || rating.description || rating.id}</span>
          </Button>
        ))}
      </div>
      
      {form.formState.errors.restfulness_id && (
        <p className="text-sm text-destructive">
          {form.formState.errors.restfulness_id.message}
        </p>
      )}
      
      <div className="flex justify-between pt-4">
        {onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-white/10 text-gray-300 hover:bg-white/5"
          >
            Back
          </Button>
        )}
        
        <Button
          type="button"
          onClick={() => onNext()}
          className="ml-auto bg-purple-500 hover:bg-purple-600 text-white"
        >
          Skip
        </Button>
      </div>
    </div>
  )
}